import { FC, HTMLAttributes } from 'react';

// import { useTranslation } from 'react-i18next';
//
// import { Button, DatePicker, Select } from 'antd';
// import cn from 'classnames';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

// import { useOffersListQuery } from 'entities/Offer';
// import { useDateFilters } from 'features/Filters/hooks/useDateFilters';
// import { EFilters } from 'features/Filters/model/enums';
// import { useMedia } from 'shared/hooks';
//
// import { OFFERS_LIMIT, OPTIONS_MAX_HEIGHT_NOTIFICATIONS } from '../../consts';
// import { useFilters } from '../../hooks/useFilters';
//
// import styles from './NotificationsFilters.module.scss';

dayjs.extend(utc);

interface INotificationsFiltersProps extends HTMLAttributes<HTMLDivElement> {}

export const NotificationsFilters: FC<INotificationsFiltersProps> = () => {
	return null;
	// const { t } = useTranslation();
	// const isMobile = useMedia();
	// const { clearFilters, getFilterValue, onFilterChange } = useFilters();
	// const { dateRange, onDateChange } = useDateFilters(EFilters.DATE_FROM, EFilters.DATE_TO);
	//
	// const [offersSearch, setOffersSearch] = useState('');
	//
	// const { data: offerList } = useOffersListQuery({

	// 	nameIcontains: offersSearch,,
	// 	...(!offersSearch && { limit: OFFERS_LIMIT }),
	// });
	//
	// const offersOptions =
	// 	offerList?.results?.map(({ name, uuid }) => ({
	// 		label: name,
	// 		value: uuid,
	// 	})) || [];
	//
	// const onOffersSearch = (value: string) => {
	// 	setOffersSearch(value.length < 3 ? '' : value);
	// };
	//
	// const allowApply = getFilterValue(EFilters.OFFER_ID) || getFilterValue(EFilters.DATE_FROM);
	//
	// return (
	// 	<div {...props} className={cn(className, styles.notificationsFilters)}>
	// 		<Select
	// 			className={styles.select}
	// 			value={getFilterValue(EFilters.OFFER_ID)}
	// 			options={offersOptions}
	// 			onChange={(value) => onFilterChange(EFilters.OFFER_ID, value)}
	// 			placeholder={t('Select offer')}
	// 			size="large"
	// 			showSearch={{
	// 					onSearch: onOffersSearch,
	// 				}}
	// 			listHeight={OPTIONS_MAX_HEIGHT_NOTIFICATIONS}
	// 		/>
	//
	// 		<DatePicker.RangePicker value={dateRange} onChange={onDateChange} format="YYYY-MM-DD" size="large" />
	//
	// 		{!isMobile && (
	// 			<div className={styles.buttons}>
	// 				<Button size="large" onClick={clearFilters} block disabled={!allowApply}>
	// 					{t('Clear')}
	// 				</Button>
	// 			</div>
	// 		)}
	// 	</div>
	// );
};
